import { render, staticRenderFns } from "./IconLinkContent.vue?vue&type=template&id=36c7083a"
import script from "./IconLinkContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconLinkContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports